import type { ReactNode } from 'react'
import { Menu, Button } from '@mantine/core'
import { IconChevronDown } from '@tabler/icons-react'

interface ActionMenuItem {
  label: ReactNode
  onClick?: () => void
  /** Renders a divider above this item. */
  dividerBefore?: boolean
  disabled?: boolean
  disabledHint?: string
  icon?: ReactNode
}

/**
 * The mockup's `Actions ▾` dropdown.
 *
 * Disabled items stay visible with a hint, matching the coming-soon convention
 * used in the nav — the shape of what a surface will eventually do stays legible.
 */
export function ActionMenu({ label = 'Actions', items }: { label?: ReactNode; items: ActionMenuItem[] }) {
  return (
    <Menu position="bottom-end" shadow="md" width={220}>
      <Menu.Target>
        <Button
          variant="default"
          size="compact-sm"
          rightSection={<IconChevronDown size={14} stroke={2} />}
        >
          {label}
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        {items.map((item, i) => (
          <div key={i}>
            {item.dividerBefore && <Menu.Divider />}
            <Menu.Item
              leftSection={item.icon}
              disabled={item.disabled}
              title={item.disabled ? item.disabledHint : undefined}
              onClick={item.onClick}
            >
              {item.label}
            </Menu.Item>
          </div>
        ))}
      </Menu.Dropdown>
    </Menu>
  )
}
